// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__bZhpR","root-content":"classes_root-content__3EO94","show":"classes_show__BZPzs","title":"classes_title__2UxcU","carrot":"classes_carrot__3y22w"};